const MAPS_LOAD_TIMEOUT_MS = 30000

export function mapsAvailable() {
  return typeof google !== 'undefined' && typeof google.maps?.Map === 'function'
}

export function whenMapsReady(callback) {
  ensureMapsLoaded()
    .then(() => callback())
    .catch((error) => {
      console.error('Google Maps failed to load', error)
    })
}

function waitForMapsCallback() {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error('Timed out waiting for Google Maps callback'))
    }, MAPS_LOAD_TIMEOUT_MS)

    window.addEventListener(
      'google-maps-callback',
      () => {
        clearTimeout(timeoutId)
        resolve()
      },
      { once: true }
    )
  })
}

async function ensureMapsLoaded() {
  if (mapsAvailable()) return

  if (typeof google === 'undefined' || typeof google.maps?.importLibrary !== 'function') {
    await waitForMapsCallback()
  }

  if (!mapsAvailable() && typeof google.maps?.importLibrary === 'function') {
    await google.maps.importLibrary('maps')
  }

  if (!mapsAvailable()) {
    throw new Error('Google Maps Map constructor is not available')
  }
}
